<template>
  <div v-if="publisherName" class="direct-debit-subscription-info">
    <span>
      <b>Direct Debit subscriptions:</b> Automatically renew with
      <button v-if="!showPublisherName" type="button" class="direct-debit-subscription-info__publisher-toggle" @click="togglePublisherName">
        the publisher
      </button>
      <span v-else class="direct-debit-subscription-info__publisher-name">{{ publisherName }}</span>
      at the stated frequency and price, unless otherwise communicated. You can cancel anytime to stop any future renewals, or within 14 days of your initial purchase for a full
      refund.
    </span>
  </div>
</template>

<script>
export default {
  name: 'DisectDebitSubscritionInfo',
  data() {
    return {
      showPublisherName: false
    }
  },
  computed: {
    publisherName() {
      return this.$parent?.dataUI?.magazine?.publisher || ''
    }
  },
  methods: {
    togglePublisherName() {
      this.showPublisherName = !this.showPublisherName
    }
  }
}
</script>

<style lang="scss" scoped>
.direct-debit-subscription-info {
  margin: 15px;
  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  line-height: 20px;
  text-align: left;
  color: #212529;

  &__publisher-toggle {
    display: inline;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    text-decoration: inherit;
    cursor: pointer;
    font: inherit;
    font-weight: 700;
    text-decoration: underline;
  }

  &__publisher-name {
    margin-top: 8px;
    font-weight: 700;
    display: inline;
  }
}
@media (max-width: $screen-xs-max) {
  .direct-debit-subscription-info {
    margin: 15px 15px 5px 15px !important;
  }
}
</style>
